import dataVF from '@/views/layout/dataVisualizationFrame'
import ECharts from 'vue-echarts'
import YMDAtimeSelect from '@/views/layout/dataVisualizationFrame/components/YMDAtimeSelect.vue'
import { queryAssetData } from '@/api/tsdb-controller'
import { removeSlash } from '@/utils/removeIdSlash.js'
import QueryTable from '@/components/QueryTable/'
import Treeselect from '@riophae/vue-treeselect'
import { TrueExcel } from '@/utils/exportExcel'
import { dwnai, ndwnai } from '@/utils/processNumber' // , Download
const moment = require('moment')

export const baseMixin = {
  components: {
    dataVF,
    YMDAtimeSelect,
    chart: ECharts,
    QueryTable,
    Treeselect
  },
  props: ['area', 'energyType', 'assetList', 'energyTextMap', 'flatEnergyType', 'paramString', 'themeDark'],
  data() {
    return {
      excel: new TrueExcel(),
      date: ['month', [moment().startOf('month').valueOf(), moment().endOf('month').add(1, 'ms').valueOf()]],
      selectedArea: null,
      tsdbData: {},
      queryUsable: false,
      areaNormalizer(node) {
        return {
          id: node.assetId
        }
      },
      energyTypeNormalizer(node) {
        return {
          // id: node.energyCatagory
          id: node.energyType
        }
      },
      selectedEnergyType: this.flatEnergyType[0] ? this.flatEnergyType[0].energyType : null
    }
  },
  mounted() {
  },
  computed: {
    selectedEnergyTypeDetail() {
      let detail = {}
      function search(energyType, selectedEnergyType) {
        for (const item of energyType) {
          // if (item.energyCatagory === selectedEnergyType) {
          if (item.energyType === selectedEnergyType) {
            detail = item
          } else if (item.children) {
            search(item.children, selectedEnergyType)
          }
        }
      }

      search(this.energyType, this.selectedEnergyType)
      return detail
    },
    readyForQuery() {
      if (this.selectedArea && this.selectedEnergyType && this.date[1]) {
        return false
      } else {
        return true
      }
    },
    ids() {
      const ids = []
      if (Array.isArray(this.selectedArea)) {
        for (const item of this.selectedArea) {
          ids.push(removeSlash(item))
        }
      } else {
        ids.push(removeSlash(this.selectedArea))
      }
      return ids
    },
    queryData() {
      return {
        start: this.date[1][0],
        end: moment(this.date[1][1]).valueOf(),
        type: this.timeReslution,
        attribute: this.selectedEnergyType,
        assetIds: this.ids
      }
    }
  },
  methods: {
    dwnai,
    ndwnai,
    checkReady(cb) {
      if (this.readyForQuery) {
        cb()
      } else {
        this.$nextTick(() => {
          this.checkReady(cb)
        })
      }
    },
    getTSDBData() {
      this.queryUsable = true
      this.queryResult = {}
      const pId = this.$store.state.app.project.id.id
      queryAssetData(this.queryData, removeSlash(pId)).then(res => {
        this.postProcess(res.data)
        setTimeout(() => {
          this.queryUsable = false
        }, 1000)
      }).catch(error => {
        this.$message(error)
      })
    },
    exportData() {
      this.excel.addElTable(this.$refs.elTable.$refs.tableBody)
      this.postExport()
    },
    postExport() {
      // pass
      if (this.$refs.charts1) {
        const charts1 = this.$refs.charts1
        const { width, height } = charts1
        const img1 = {
          src: charts1.getDataURL({
            pixelRatio: window.devicePixelRatio || 1
          }),
          width,
          height
        }
        // console.log(img1)
        this.excel.addImage(img1)
      }
      if (this.$refs.charts2) {
        const charts2 = this.$refs.charts2
        const { width, height } = charts2
        const img2 = {
          src: charts2.getDataURL({
            pixelRatio: window.devicePixelRatio || 1
          }),
          width,
          height
        }
        // console.log(img1)
        this.excel.addImage(img2)
      }
      this.excel.export()
    }
  }
}
